class videoPlayer {
  constructor(parent) {
    if (parent.length === 0) {
      return
    }
    this.parent = parent;
    this.init();
  }

  videoPlayPause = () => {
    let parent = this.parent;;
    parent.forEach(ele => {
      let playPauseButton = qsa('.video-play-btn-js', ele);
      playPauseButton.forEach(button => {
        button.addEventListener('click', (e) => {
          let that = e.currentTarget;
          let wrapper = that.closest('.video-player-block__video');
          let video = qs('.js-video', wrapper);
          let iconPlay = qs('.icon-video-play', button);
          let iconPause = qs('.icon-video-pause', button);
          if (video.paused) {
            video.play();
            iconPlay.classList.add('hidden');
            iconPause.classList.remove('hidden');
          } else {
            video.pause();
            iconPlay.classList.remove('hidden');
            iconPause.classList.add('hidden');
          }
        })
      });
    });
  }

  init = () => {
    this.videoPlayPause();
  }
}
new videoPlayer(qsa('video-player'));